<div class="divide-y divide-gray-200 dark:divide-gray-800">
  @for (fila of filas; track fila.uid; let i = $index) {
    @let error = mensaje(fila);
    <div class="py-4 first:pt-0">
      @if (filas.length > 1) {
        <div class="mb-3 flex items-center justify-between gap-3">
          <h4 class="text-sm font-medium text-gray-800 dark:text-white/90">Establecimiento {{ i + 1 }}</h4>
          <app-button size="sm" variant="outline" startIcon="delete" [disabled]="deshabilitada" (btnClick)="quitar(fila)">
            Quitar
          </app-button>
        </div>
      }
      <div class="grid grid-cols-1 gap-3 md:grid-cols-2">
        <div>
          <app-label [for]="'est-nombre-' + fila.uid" [isRequired]="true">Nombre</app-label>
          <app-input-field [id]="'est-nombre-' + fila.uid" [(ngModel)]="fila.nombre" [disabled]="deshabilitada" [error]="!!error && !fila.nombre.trim()" />
        </div>
        <div>
          <app-label [for]="'est-objetivo-' + fila.uid" [isRequired]="true">Objetivo</app-label>
          <app-select [id]="'est-objetivo-' + fila.uid" [(ngModel)]="fila.objetivo" placeholder="Seleccione un objetivo"
            [options]="objetivoOptions" [disabled]="deshabilitada" [error]="!!error && !fila.objetivo" />
        </div>
        <div>
          <app-label [for]="'est-zona-' + fila.uid" [isRequired]="true">Zona</app-label>
          <div class="flex items-center gap-2">
            <app-select class="min-w-0 flex-1" [id]="'est-zona-' + fila.uid" [(ngModel)]="fila.ubi_zona_id" placeholder="Seleccione una zona"
              [options]="zonasOptions" [searchable]="true" [disabled]="deshabilitada" [error]="!!error && !fila.ubi_zona_id" />
            @if (puedeCrearZona) {
              <app-icon-button icon="add" [ariaLabel]="'Nueva zona'" [tooltip]="'Nueva zona'" [disabled]="deshabilitada"
                (onClick)="crearZona(fila)" />
            }
          </div>
        </div>
        <div>
          <app-label [for]="'est-km-' + fila.uid">Kilómetro</app-label>
          <app-input-field [id]="'est-km-' + fila.uid" type="number" min="0" step="0.1" [ngModel]="fila.km"
            (ngModelChange)="onKm(fila, $event)" [disabled]="deshabilitada" />
        </div>
        <div class="md:col-span-2">
          <app-label [for]="'est-direccion-' + fila.uid">Dirección</app-label>
          <app-input-field [id]="'est-direccion-' + fila.uid" [(ngModel)]="fila.direccion" [disabled]="deshabilitada" />
        </div>
      </div>
      @if (error) {
        <p class="mt-2 text-xs text-error-500">{{ error }}</p>
      }
    </div>
  }
</div>

<button type="button" class="mt-2 inline-flex items-center gap-1 text-sm font-medium text-brand-500 hover:underline disabled:opacity-50"
  [disabled]="deshabilitada" (click)="agregar()">
  + Agregar otro establecimiento
</button>
